import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/index'

Vue.use(Router)
import VueRouter from 'vue-router'
Vue.use(VueRouter)
// router文件夹-->index.js文件
//cv以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '家品'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/pages/about/about'),
      meta: {
        title: '关于家品'
      }
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('@/pages/product/index'),
      meta: {
        title: '公司产品'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/pages/contact/index'),
      meta: {
        title: '联系我们'
      }
    },
    {
      path: '/productDetail/:productId/:typeId',
      name: 'productDetail',
      component: () => import('@/pages/productDetail/index'),
      meta: {
        title: ''
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: () => import('@/pages/detail/index'),
      meta: {
        title: ''
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    console.log('savedPosition', savedPosition)
    console.log('to', to);
    console.log('from', from);
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js